import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { JwtService } from '@app/core/services/jwt.service'
import { ActivatedRoute, Router } from "@angular/router"
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-change-password-request',
  templateUrl: './change-password-request.component.html',
  styleUrls: ['./change-password-request.component.scss']
})

export class ChangePasswordRequestComponent implements OnInit {
  public form: FormGroup;
  public errors = null;
  public successMsg = null;
  public showCompany = false;
  public franchises$ = [];
  public isEmbedMode = false;

  constructor(
    public fb: FormBuilder,
    public authService: JwtService,
    private _router: Router,
    private route: ActivatedRoute,
    private _toaster: ToastrService,
    private _translation: TranslateService
  ) {
    this.form = this.fb.group({
      usrUsername: new FormControl(''),
      usrFranchises: new FormControl(''),
      usrEmail: new FormControl('', {
        validators: [Validators.required, Validators.email],
        updateOn: 'change'
      }),
      usrFirstName: new FormControl('', {
        validators: [Validators.required],
        updateOn: 'change'
      }),
      usrLastName: new FormControl('', {
        validators: [Validators.required],
        updateOn: 'change'
      }),
      usrFranchise: new FormControl('')
    })
  }

  ngOnInit(): void {
    // Check both URL param and iframe detection
    this.route.queryParams.subscribe(params => {
      this.isEmbedMode = params['embed'] === 'true' || window !== window.top;
    });
  }

  async onNext(){
    this.form.controls['usrUsername'].setValue(this.form.controls['usrEmail'].value);
    this.authService.onValidateAccount(this.form.value).subscribe(
      res => {
        if(res.data.franchise && res.data.franchise!=null && res.data.franchise.length > 1){
          this.franchises$ = res.data.franchise;
          this.showCompany = true;
        }  
        else{
          this.form.controls['usrFranchises'].setValue(res.data.fTypeID);
          this.sendResetPasswordLink();
        } 
      },error => {
        this.sendResetPasswordLink();
      });

  }

  onSubmit(){
    this.sendResetPasswordLink();
  }

  private sendResetPasswordLink(){
    this.authService.sendResetPasswordLink(this.form.value, this.form.controls['usrFranchises'].value).subscribe(data => {
      this._toaster.success(this._translation.instant('change_password_reset'));

      if (this.isEmbedMode && window.parent !== window) {
        window.parent.postMessage({
          type: 'TRAKR_GO_LOGIN',
          redirectUrl: '/login'
        }, '*');
      } else if (this.isEmbedMode) {
        this._router.navigate(['/login'], { queryParams: { embed: 'true' } });
      } else {
        this._router.navigate(['/login']);
      }
    }, (error) => {
      this.errors = error.error.message;
    })
  }

}